import { useTheme } from 'context/ThemeContext'
import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'react'
import NavBarItem from './NavBarItem'

const THEME_EMOJI = {
  light: '☼',
  dark: '⏾',
}

export default function NavBar() {
  const { i18n } = useTranslation()
  const [selectedItem, setSelectedItem] = useState<string>('about')
  console.log(i18n.language)
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY <= 235) {
        setSelectedItem('about')
      } else if (window.scrollY > 235 && window.scrollY <= 1000) {
        setSelectedItem('experience')
      } else if (window.scrollY > 1000) {
        setSelectedItem('projects')
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const { theme, toggleTheme } = useTheme()
  const navBarItems = ['about', 'experience', 'projects']
  return (
    <header className='lg:flex justify-between sticky top-0 py-10 px-3 lg:px-0 z-10'>
      <nav className='hidden lg:block'>
        <ul className='flex border rounded-full bg-white border-neutral-200 dark:border-neutral-700 dark:bg-neutral-950 dark:text-neutral-300 px-3 py-2 shadow-xl mb-3 lg:mb-0 w-fit'>
          {navBarItems.map((item) => (
            <NavBarItem item={item} key={item} selectedItem={selectedItem} />
          ))}
        </ul>
      </nav>
      <div className='flex'>
        <div className='flex border rounded-full  bg-white border-neutral-200 dark:border-neutral-700 dark:bg-neutral-950 dark:text-neutral-300 px-3 py-2 mr-2 shadow-xl'>
          <button
            className={`toggle-item ${i18n.resolvedLanguage === 'fr' ? 'toggle-item-selected' : 'cursor-pointer'}`}
            onClick={() => i18n.changeLanguage('fr')}
            disabled={i18n.resolvedLanguage === 'fr'}
          >
            fr
          </button>
          <button
            className={`toggle-item ${i18n.resolvedLanguage === 'en' ? 'toggle-item-selected' : 'cursor-pointer'}`}
            onClick={() => i18n.changeLanguage('en')}
            disabled={i18n.resolvedLanguage === 'en'}
          >
            en
          </button>
        </div>
        <div className='flex border rounded-full  bg-white border-neutral-200 dark:border-neutral-700 dark:bg-neutral-950 dark:text-neutral-300 px-3 py-2 mr-2 shadow-xl'>
          <button className={`toggle-item ${theme === 'light' ? 'toggle-item-selected' : 'cursor-pointer'}`} onClick={toggleTheme} disabled={theme === 'light'}>
            {THEME_EMOJI.light}
          </button>
          <button className={`toggle-item ${theme === 'dark' ? 'toggle-item-selected' : 'cursor-pointer'}`} onClick={toggleTheme} disabled={theme === 'dark'}>
            {THEME_EMOJI.dark}
          </button>
        </div>
      </div>
    </header>
  )
}
